export enum StripeProducts {
    cooking_beta = 'prod_Ja0zmBgIVyPmnJ',
    recipe_subscription = 'price_1O0VHDFfSnBEafLxxwSwFfqE'
  }

export enum ItemsDomains {
    cooking_beta = 'cooking'
}